import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface iModalConfirm {
  text?: string;
  error?: boolean;
  success?: boolean;
  email?: boolean;
  delete?: boolean;
  successText?: string;
  errorText?: string;
  type?: string;
};

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss']
})
export class ModalConfirmComponent implements OnInit {
  confirm: boolean = false;
  error: boolean = false;
  default: boolean = true;
  email: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: iModalConfirm,
    public dialogRef: MatDialogRef<ModalConfirmComponent>,
  ) { }

  ngOnInit(): void {
    if (this.data.error) {
      this.default = false;
      this.error = true;
    }

    if (this.data.success) {
      this.default = false;
      this.confirm = true;
    }

    if(this.data.email){
      this.default = false;
      this.email = true;
    }
  }

  submit() {
    this.dialogRef.close({ confirm: true });
  }

  closeModal() {
    this.dialogRef.close({ confirm: false });
  }

}
